module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row0_appleQRcode.5b9a198e.png";